import { render, staticRenderFns } from "./HTMLBuilder.vue?vue&type=template&id=c3c50d5c&scoped=true&"
import script from "./HTMLBuilder.vue?vue&type=script&lang=js&"
export * from "./HTMLBuilder.vue?vue&type=script&lang=js&"
import style0 from "./HTMLBuilder.vue?vue&type=style&index=0&id=c3c50d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c50d5c",
  null
  
)

export default component.exports